import React from "react";
import { AiOutlineCheck } from "react-icons/ai";

const CampoTexto = ({ 
    label, 
    name, 
    placeholder, 
    obrigatorio=true, 
    valor, aoAlterado, pattern, readOnly, disabled, display = true }) => {
    if (!display) return null; // Não renderiza nada se display for falso

    const preenchido = valor?.trim() !== ""; // Verifica se o campo está preenchido

    return (
        <div className="mb-4">
            <label className="flex items-center text-sm font-medium text-gray-700">
                {label}
                {obrigatorio && !preenchido && (
                    <span className="ml-1 text-red-500">*</span>
                )}
                {preenchido && (
                    <AiOutlineCheck className="ml-2 text-green-500" aria-label="Preenchido" />
                )}
            </label>
            <input
                type="text"
                name={name}
                placeholder={placeholder}
                required={obrigatorio}
                value={valor}
                onChange={(e) => aoAlterado(e.target.value)}
                pattern={pattern}
                className={`w-full border rounded-md p-2 
                    focus:outline-none focus:ring-0 focus:border-gray-500 
                    ${preenchido ? "border-gray-500" : "border-gray-300"} 
                    ${disabled ? "cursor-not-allowed" : ""}`}
                readOnly={readOnly}
                disabled={disabled}
            />
        </div>
    );
};

export default CampoTexto;